import {Box, BoxProps} from '@chakra-ui/react'

type SpacerProps = BoxProps

export default function Spacer({height, width, ...props}: SpacerProps) {
  return (
    <Box
      aria-hidden
      as="span"
      className="spacer"
      display="block"
      height={height ?? 'px'}
      minHeight={height ?? 'px'}
      minWidth={width ?? 'px'}
      userSelect="none"
      width={width ?? 'px'}
      {...props}
    />
  )
}
